import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}
    :host {
        display: inline-block;
        width: var(--icon-size, 1em);
        height: var(--icon-size, 1em);
        contain: strict;
        box-sizing: content-box !important;
    }
    .icon,
    svg {
        fill: var(--icon-fill-color, currentcolor);
        display: block;
        height: 100%;
        width: 100%;
    }
`;
//# sourceMappingURL=icon.styles.js.map